import Button from "ui/buttons/Button";
import { Message } from "ui/text/Message";

type SalesStaffAccessWarningProps = {
  assigneeName: string;
  resourceLabel: string;
  onRemoveAssignment: () => void;
  onGrantAccess?: () => Promise<void>;
  canGrantAccess: boolean;
};

export default function SalesStaffAccessWarning({
  assigneeName,
  resourceLabel,
  onRemoveAssignment,
  onGrantAccess,
  canGrantAccess,
}: SalesStaffAccessWarningProps) {
  return (
    <div style={{ marginTop: 12 }}>
      <Message variant="inverted" messageType="warning">
        <div>
          <div>
            {assigneeName} is assigned as sales staff but no longer has access to this {resourceLabel}.
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            {canGrantAccess && onGrantAccess ? (
              <Button btnStyle="secondary" btnSize="small" onClick={onGrantAccess}>
                Grant View Access
              </Button>
            ) : null}
            <Button btnStyle="tertiary" btnSize="small" onClick={onRemoveAssignment}>
              Remove Assignment
            </Button>
          </div>
        </div>
      </Message>
    </div>
  );
}
